<template>
  <div class="row">
    <slot></slot>
    <div class="col-12">
      <div class="button-wrap d-flex validation-button justify-content-end">
        <p class="obligatoire">* Champs obligatoire</p>
        <b-button variant="outline-primary" @click.prevent="previousStep"
          >Annuler</b-button
        >
        <b-button
          type="button"
          variant="primary"
          class="lg-btn"
          @click.prevent="nextStep"
          >Suivant</b-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1
    }
  },
  methods: {
    previousStep () {
      this.$emit('handlePreviousStep')
    },
    nextStep () {
      this.$emit('handleNextStep')
    }
  }
}
</script>
<style lang="scss">
.h2-title {
  font-size: 18px;
  color: #2b3085;
  margin-bottom: 25px;
  font-weight: 600;
  font-family: "Open sans";
}
</style>



// WEBPACK FOOTER //
// src/components/editSteppedModal/stepComponent.vue